import GlobalCard from '../../GlobalCard/GlobalCard';
import { ApiHubTotalData } from './ApiHubTotalData';
import LeaderBoard from './LeaderBoard';
import LeaderBoardDataProvider from '../../../Contexts/LeaderBoardDataContext';

import UserTable from '../UserTable'
import AppStudioGraphContainer from '../../AppStudio/AppStudioGraphContainer';
import ApiCategoryDonutGraph from '../ApiCategoryDonutGraph';

const Cards = () => {
  const apiHubTotalData = ApiHubTotalData();
  // const apiHubCardData = ApiHubCardData();

  return (
    <div className='flex flex-row gap-[8px] w-full flex-grow h-[60vh] '>
      <div className='w-[75%] h-full'>
        <div className='flex flex-col gap-[8px] h-full '>
          <div className="flex flex-wrap w-full h-[28%] ">
            <GlobalCard data={apiHubTotalData} userTable={({ onClose }) => (
              <UserTable title="Total Users" onClose={onClose} />
            )} />
          </div>
          <div className='border-[#CCD4DA] shadow-custom rounded-[12px] h-[78%] '>

            <AppStudioGraphContainer header="Api Count Per Category" Component={ApiCategoryDonutGraph} className="" />
          </div>

        </div>
      </div>
      <div className='w-[25%]'>
        <LeaderBoardDataProvider>
          <LeaderBoard />
        </LeaderBoardDataProvider>
      </div>
    </div>
  );
};

export default Cards;
